import React, { useState } from 'react';
import { Mail, Check, Loader2 } from 'lucide-react';
import { subscribeNewsletter } from '../api';

// variant: 'light' (on cream bg) or 'dark' (on navy bg, e.g. footer)
const Newsletter = ({ variant = 'light' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email || status === 'loading') return;
    setStatus('loading');
    try {
      const res = await subscribeNewsletter(email);
      setStatus('done');
      setMessage(res.message || 'Subscribed!');
      setEmail('');
    } catch (err) {
      setStatus('error');
      setMessage(
        err?.response?.data?.detail?.[0]?.msg
          ? 'Please enter a valid email address.'
          : 'Something went wrong. Please try again.'
      );
    }
  };

  const dark = variant === 'dark';

  return (
    <div className={dark ? '' : 'rounded-2xl border border-[#E6D7A2] bg-[#EFE7D2] p-7'}>
      <div className="flex items-center gap-2">
        <Mail className={`w-5 h-5 ${dark ? 'text-[#CBA344]' : 'text-[#e0564e]'}`} />
        <h3 className={`font-display text-[20px] font-semibold ${dark ? 'text-white' : 'text-[#1B1D21]'}`}>
          2026 entry-rule updates
        </h3>
      </div>
      <p className={`mt-2 text-[14px] leading-relaxed ${dark ? 'text-[#9fb2c4]' : 'text-[#4B4F58]'}`}>
        Get an email when UAE visa, entry or travel rules change. No spam — just the updates that matter.
      </p>

      {status === 'done' ? (
        <div className={`mt-4 flex items-center gap-2 text-[15px] font-medium ${dark ? 'text-[#7fd1c8]' : 'text-[#2F663C]'}`}>
          <Check className="w-5 h-5" /> {message}
        </div>
      ) : (
        <form onSubmit={submit} className="mt-4 flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className={`flex-1 rounded-full px-5 py-3 text-[15px] outline-none transition-shadow focus:ring-2 ${
              dark
                ? 'bg-white/10 text-white placeholder-[#9fb2c4] focus:ring-[#CBA344]'
                : 'bg-white border border-[#E6D7A2] text-[#1B1D21] placeholder-[#9aa7b3] focus:ring-[#e0564e]'
            }`}
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="btn-sunset inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-[15px] font-semibold disabled:opacity-70"
          >
            {status === 'loading' ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Subscribe
          </button>
        </form>
      )}
      {status === 'error' && (
        <p className="mt-2 text-[13px] text-[#e0564e]">{message}</p>
      )}
    </div>
  );
};

export default Newsletter;
